import _jsx from "@babel/runtime/helpers/jsx";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import { defineMessages } from 'react-intl';
import _ from 'lodash';
import getVideoId from 'get-video-id';
import notAuthorized from '../not-authorized';
import LessonDetails from './LessonDetails';
import OnlineProvider from '../../components/OnlineProvider/OnlineProvider';
import { getLessonBySlug, getLessonTextNotes, getLessonVideoNotes, resetTextNotes, resetVideoNotes } from '../../actions/lessonDetails';
import { getCourseBySlug } from '../../actions/courseDetails';
import { getTranscodingJobs } from '../../actions/transcodingJobs';
import { isIOS, isIOSServer, ssrRequest } from '../../helpers';
import isLoggedIn from '../../helpers/checkAuth';
import notFound from '../not-found';
import ContextProvider from '../../components/ContextProvider/ContextProvider';
import { getFirstForcedProgressionItem, getForcedProgressionItemPath, isItemBlockedByApprovalStep, isItemDisabledByForcedProgression, isItemInHiddenSection } from '../../helpers/forcedProgression';
var messages = defineMessages({
  lessonTitle: {
    id: "LessonDetails.lessonTitle",
    defaultMessage: [{
      "type": 0,
      "value": "lesson"
    }]
  }
});
function action(_x) {
  return _action.apply(this, arguments);
}
function _action() {
  _action = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(context) {
    var _this = this;
    var store, params, fetch, query, formatMessage, cloudfrontUrl, userAgent, lessonSlug, courseSlug, _store$getState, auth, promises, requests, _store$getState2, lessonDetails, courseDetails, urlVideoVimea, _ref3, service, posterVimeo, vimeoRes, vimeoResJson, notAuthorizedReq, notFoundReq, course, requestedItem, firstIncompleteItem, isBlockedByApproval, isHiddenItem, title, imageUrl;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          store = context.store, params = context.params, fetch = context.fetch, query = context.query, formatMessage = context.intl.formatMessage, cloudfrontUrl = context.cloudfrontUrl, userAgent = context.userAgent;
          lessonSlug = params.lessonSlug, courseSlug = params.courseSlug;
          _store$getState = store.getState(), auth = _store$getState.auth;
          _context3.next = 5;
          return store.dispatch(resetTextNotes());
        case 5:
          _context3.next = 7;
          return store.dispatch(resetVideoNotes());
        case 7:
          promises = [];
          if (courseSlug !== undefined) {
            promises.push(function () {
              return ssrRequest({
                getAction: getCourseBySlug.bind(_this, courseSlug),
                store: store,
                fetch: fetch,
                context: context
              });
            });
          }
          promises.push(function () {
            return ssrRequest({
              getAction: getLessonBySlug.bind(_this, lessonSlug, {
                courseId: courseSlug
              }),
              store: store,
              fetch: fetch,
              context: context
            });
          });
          if (isLoggedIn(auth) && courseSlug) {
            promises.push( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    return _context.abrupt("return", ssrRequest({
                      getAction: getLessonTextNotes.bind(_this, courseSlug, lessonSlug),
                      store: store,
                      fetch: fetch,
                      context: context
                    }));
                  case 1:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            })));
          }
          if (isLoggedIn(auth)) {
            promises.push( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    return _context2.abrupt("return", ssrRequest({
                      getAction: getTranscodingJobs.bind(_this, {
                        page: 1,
                        perPage: 10,
                        lessonId: lessonSlug,
                        'status[0]': 'pending',
                        'status[1]': 'processing'
                      }),
                      store: store,
                      fetch: fetch,
                      context: context
                    }));
                  case 1:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2);
            })));
          }
          _context3.next = 14;
          return Promise.all(promises.map(function (promise) {
            return promise();
          }));
        case 14:
          requests = _context3.sent;
          _store$getState2 = store.getState(), lessonDetails = _store$getState2.lessonDetails, courseDetails = _store$getState2.courseDetails;
          if (!(isLoggedIn(auth) && courseSlug && !_.get(lessonDetails, 'lesson.youtubeVideoUrl'))) {
            _context3.next = 22;
            break;
          }
          _context3.t0 = requests;
          _context3.next = 20;
          return ssrRequest({
            getAction: getLessonVideoNotes.bind(this, courseSlug, lessonSlug),
            store: store,
            fetch: fetch,
            context: context
          });
        case 20:
          _context3.t1 = _context3.sent;
          _context3.t0.push.call(_context3.t0, _context3.t1);
        case 22:
          urlVideoVimea = _.get(lessonDetails, 'lesson.youtubeVideoUrl');
          _ref3 = urlVideoVimea ? getVideoId(urlVideoVimea) : {}, service = _ref3.service;
          posterVimeo = '';
          if (!(service === 'vimeo')) {
            _context3.next = 39;
            break;
          }
          _context3.prev = 26;
          _context3.next = 29;
          return fetch("https://vimeo.com/api/oembed.json?url=".concat(encodeURI(urlVideoVimea)));
        case 29:
          vimeoRes = _context3.sent;
          _context3.next = 32;
          return vimeoRes.json();
        case 32:
          vimeoResJson = _context3.sent;
          posterVimeo = vimeoResJson.thumbnail_url;
          _context3.next = 39;
          break;
        case 36:
          _context3.prev = 36;
          _context3.t2 = _context3["catch"](26);
          console.error(_context3.t2);
        case 39:
          notAuthorizedReq = _.find(requests, function (item) {
            return _.get(item, 'status') === 401;
          });
          notFoundReq = _.find(requests, function (item) {
            return _.get(item, 'status') >= 400;
          });
          if (!notAuthorizedReq) {
            _context3.next = 43;
            break;
          }
          return _context3.abrupt("return", notAuthorized(context));
        case 43:
          if (!notFoundReq) {
            _context3.next = 45;
            break;
          }
          return _context3.abrupt("return", notFound(context));
        case 45:
          course = _.get(courseDetails, 'course');
          requestedItem = _(_.get(course, 'sections', [])).map('items').flatten().find(function (sectionItem) {
            return sectionItem.itemType === 'Lesson' && _.get(sectionItem, 'item._id') === _.get(lessonDetails, 'lesson._id');
          });
          firstIncompleteItem = getFirstForcedProgressionItem(course);
          isBlockedByApproval = requestedItem && isItemBlockedByApprovalStep(course, requestedItem);
          isHiddenItem = requestedItem && isItemInHiddenSection(course, requestedItem);
          if (!(isLoggedIn(auth) && requestedItem && (isHiddenItem || isBlockedByApproval || isItemDisabledByForcedProgression(course, requestedItem, firstIncompleteItem)))) {
            _context3.next = 52;
            break;
          }
          return _context3.abrupt("return", {
            redirect: (isHiddenItem || isBlockedByApproval ? "/courses/".concat(courseSlug) : getForcedProgressionItemPath(course, firstIncompleteItem)) || "/courses/".concat(courseSlug)
          });
        case 52:
          title = "".concat(_.get(lessonDetails, 'lesson.name', ''), " - ").concat(formatMessage(messages.lessonTitle));
          imageUrl = _.get(lessonDetails, 'lesson.preview.path') || _.get(courseDetails, 'course.thumbnail.path');
          if (imageUrl) {
            imageUrl = "".concat(cloudfrontUrl, "/").concat(imageUrl);
          }
          return _context3.abrupt("return", {
            chunks: ['lesson-details'],
            title: title,
            imageUrl: imageUrl,
            component: /*#__PURE__*/_jsx(ContextProvider, {
              context: context
            }, void 0, /*#__PURE__*/_jsx(OnlineProvider, {
              path: context.path
            }, void 0, /*#__PURE__*/_jsx(LessonDetails, {
              courseSlug: courseSlug,
              data: {},
              title: title,
              query: query,
              posterVimeo: posterVimeo,
              isIOS: isIOSServer(userAgent) || isIOS(),
              searchSessionId: query.searchSessionId
            })))
          });
        case 56:
        case "end":
          return _context3.stop();
      }
    }, _callee3, this, [[26, 36]]);
  }));
  return _action.apply(this, arguments);
}
export default action;